import { LogErrors } from './../../../LogErrors'

import { DoubleAttempt } from './../../Helpers/DoubleAttempt'


const ValidateAccessCode = async (accessCode) => {
    try {
        const dataToSend = {
            accessCode: accessCode
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/ValidateAccessCodeZtudiante"

        const response = await DoubleAttempt(url, parameters, false)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response?.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/ValidateAccessCodeZtudiante", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json'
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: null }
    } catch (error) {
        await LogErrors('ValidateAccessCode - DL SignUp', error)
        return { success: false, message: 'No ha sido posible validar el código Ztudia. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const CreateAccountAndAddToGroup = async (accessCode, user, name, lastName) => {
    try {
        const dataToSend = {
            accessCode: accessCode,
            user: user,
            name: name,
            lastName: lastName
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/CreateZtudianteAccessCode"

        const response = await DoubleAttempt(url, parameters, false)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response?.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/CreateZtudianteAccessCode", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json'
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: null }
    } catch (error) {
        await LogErrors('CreateAccountAndAddToGroup - DL SignUp', error)
        return { success: false, message: 'No ha sido posible asociarte al grupo deseado. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const AddToGroup = async (accessCode, user, password) => {
    try {
        const dataToSend = {
            accessCode: accessCode,
            user: user,
            password: password
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/AddToGroup"

        const response = await DoubleAttempt(url, parameters, false)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response?.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/AddToGroup", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json'
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: null }
    } catch (error) {
        await LogErrors('AddToGroup - DL SignUp', error)
        return { success: false, message: 'No ha sido posible asociarte al grupo deseado. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

export { ValidateAccessCode, CreateAccountAndAddToGroup, AddToGroup };